import { AfterpayMessage } from "~/utils/Afterpay"
import { Grid } from "semantic-ui-react"
import { APMessage, GemMessage } from "./CombinationPaymentList.styles"
import { getCurrentBasket, getEmptyBasket } from "@stateManagement/localStorage/basket"
import { isMobile } from "@utils/Helpers"
import { useEffect, useState } from "react"
import { useFetcher } from "@remix-run/react"
import { BasketResponseModel } from "~/dataModels/BasketModel"

interface CombinationPaymentListProps {
  basePrice: number
  isMobile?: boolean | false
  isCenter?: boolean | false
}

export const CombinationPaymentList = (
  props: CombinationPaymentListProps
) => {
  const fetcher = useFetcher();
  const [basket, setBasket] = useState(getEmptyBasket())
  const [isAllowedAfterPay, setIsAllowedAfterPay] = useState('false')

  useEffect(() => {    
    //fetcher.load("/api/order-data")
  },[])

  useEffect(() => {
    if(fetcher.data) {
      setBasket(fetcher.data as BasketResponseModel)
    }
  }, [fetcher.data])

  const { basePrice, isCenter } = props
  //const isAllowedAfterPay = getAllowAfterToLocalStorage()
  const isDirectMobile =  isMobile()

  return (
    <div style={{marginTop: '8px'}}>
      <Grid.Column width={16}>
          <GemMessage className="flex items-center justify-center flex-wrap md:justify-start">
            or 6 months interest-free with Gem Visa
           <img 
            className="w-[40px] h-[23px] md:w-[59px] h-[37px]" 
            src="https://assets-au-01.kc-usercontent.com/b4867b92-df10-028b-fef2-a66cd00381c7/3366a377-06e7-45af-85ef-1ba3443400f7/gem.png"
           />
          </GemMessage>
      </Grid.Column>
      <Grid.Column width={16}>
          <APMessage style={{display: isCenter ? 'inline-block': ''}} isMobile={isDirectMobile}>
            {((basket.summary.promotionCode === undefined || basket.summary.promotionCode === '') || isAllowedAfterPay === 'true') && <AfterpayMessage amount={basePrice} size="xs" isMobile={isDirectMobile}/>}
          </APMessage>
      </Grid.Column>
    </div>
  )
}